import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_SUBCONTRACTOR} from '../../constants';

export default {
  id: 'ACCES_DOSS',
  title: 'Come faccio ad accedere agli archivi del mio fornitore?',
  description: '',
  categories: [CONTENT_CATEGORY_SUBCONTRACTOR],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Gli archivi corrispondono ai documenti validi. Sono conservati per una durata di 15 anni.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Dalla cartella del fornitore, fare clic su «Archivi».'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ACCES_DOSS/IT_ACCES_DOSS.png`
  }]
};
